<ng-template #rightContentTpl>
  @if (ambassadorInviteRightContent) {
    <div class="right-content m-auto w-full lg:w-1/2 xs:p-v-spacing py-v-spacing">
      <div class="wysiwyg" [innerHTML]="ambassadorInviteRightContent"></div>
    </div>
  }
</ng-template>

<div
  [className]="theme?.root + ' bg-no-repeat bg-center bg-cover ambassador-invite-component'"
  [style]="theme?.bgImage"
>
  <div class="container {{ theme?.container }}">
    <!-- Existing layout - shown when user is NOT logged in -->
    @if (!isLoggedIn) {
      <div class="section-container flex items-center justify-center flex-col-reverse lg:flex-row-reverse">
        <ng-container *ngTemplateOutlet="rightContentTpl"></ng-container>
        <div
          class="p-0 {{ ambassadorInviteRightContent ? 'lg:w-1/2' : '' }} w-full"
        >
          <div
            class="content-section w-full xs:p-v-spacing py-v-spacing"
            [ngClass]="{
              'sm:px-v-spacing max-w-container': !ambassadorInviteRightContent
            }"
          >
            <div class="lg:w-full lg:mr-v-spacing lg:pr-v-spacing">
              @if (ambassadorInviteTitle) {
                <div class="wysiwyg !mb-4 layout-title" [innerHTML]="ambassadorInviteTitle"></div>
              }
              @if (ambassadorInviteContent) {
                <div class="wysiwyg" [innerHTML]="ambassadorInviteContent"></div>
              }
            </div>
            <div class="lg:w-full pt-8 flex">
              <button
                [className]="buttonProps.style + '-button' + ' lg:!w-auto v-button w-min whitespace-nowrap ambassador-invite-cta raf-trigger'"
              >
                {{ buttonProps.label }}
              </button>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Logged-in layout - shown when user has an ambassador URL -->
    @if (isLoggedIn) {
      <div class="section-container flex items-center justify-center flex-col-reverse lg:flex-row-reverse">
        <ng-container *ngTemplateOutlet="rightContentTpl"></ng-container>
        <div
          class="p-0 {{ ambassadorInviteRightContent ? 'lg:w-1/2' : '' }} w-full"
        >
          <div
            class="content-section w-full xs:p-v-spacing py-v-spacing"
            [ngClass]="{
              'sm:px-v-spacing max-w-container': !ambassadorInviteRightContent
            }"
          >
            <div class="lg:w-full lg:mr-v-spacing lg:pr-v-spacing">
              @if (ambassadorInviteTitle) {
                <div class="wysiwyg !mb-4 layout-title" [innerHTML]="ambassadorInviteTitle"></div>
              }
              @if (ambassadorInviteContent) {
                <div class="wysiwyg" [innerHTML]="ambassadorInviteContent"></div>
              }
            </div>
            <div class="lg:w-full flex flex-col items-start">
              <div class="flex items-center border border-gray-300 rounded-2xl px-5 py-3 mb-6 w-full bg-white">
                <span class="flex-1 text-vis-regular text-left truncate">{{ loggedInAmbassadorUrl }}</span>
                <button
                  type="button"
                  (click)="copyAmbassadorUrl()"
                  class="ml-3 text-vis-regular hover:opacity-70"
                  [attr.aria-label]="urlCopied ? 'Copied!' : 'Copy link'"
                >
                  <fa-icon [icon]="faCopyUrl"></fa-icon>
                </button>
              </div>
              <button
                type="button"
                [className]="buttonProps.style + '-button v-button rounded-full whitespace-nowrap raf-trigger'"
              >
                Share Link <fa-icon [icon]="faShareLink" class="ml-1"></fa-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
